/* eslint-disable */
import '../Scss/style.scss';
import { defineAsyncComponent } from 'vue';
import { Component } from '@vue/runtime-core';
import createApp from '@digitalwerk/frontend-muster';
import Swiper, { SwiperOptions } from 'swiper';

const PageHeader = defineAsyncComponent(() => import('./Components/PageHeader.vue'));
const NewsList = defineAsyncComponent(() => import('./Components/NewsList.vue'));
const NewsLatest = defineAsyncComponent(() => import('./Components/NewsLatest.vue'));
const JobList = defineAsyncComponent(() => import('./Components/JobList.vue'));
const Search = defineAsyncComponent(() => import('./Components/Search.vue'));
const Gallery = defineAsyncComponent(() => import('./Components/Gallery.vue'));
const PageHeroSlider = defineAsyncComponent(() => import('./Components/PageHeroSlider.vue'));
const BenefitsSlider = defineAsyncComponent(() => import('./Components/BenefitsSlider.vue'));
const Statistics = defineAsyncComponent(() => import('./Components/Statistics.vue'));
const Accordion = defineAsyncComponent(() => import('./Components/Accordion.vue'));
const Collapse = defineAsyncComponent(() => import('./Components/Collapse.vue'));
const Quote = defineAsyncComponent(() => import('./Components/Quote.vue'));
const Logowall = defineAsyncComponent(() => import('./Components/Logowall.vue'));

// GravityForm component and inputs
const GravityForm = defineAsyncComponent(() => import('./Components/GravityForm.vue'));
const GfCheckboxes = defineAsyncComponent(() => import('./Components/GravityFormElements/Checkboxes.vue'));
const GfConsent = defineAsyncComponent(() => import('./Components/GravityFormElements/Consent.vue'));
const GfFileUpload = defineAsyncComponent(() => import('./Components/GravityFormElements/FileUpload.vue'));
const GfInput = defineAsyncComponent(() => import('./Components/GravityFormElements/Input.vue'));
const GfRadioButtons = defineAsyncComponent(() => import('./Components/GravityFormElements/RadioButtons.vue'));
const GfSelect = defineAsyncComponent(() => import('./Components/GravityFormElements/Select.vue'));
const GfTextarea = defineAsyncComponent(() => import('./Components/GravityFormElements/Textarea.vue'));

const projectRootComponent:Component = {
  components: {
    'page-header': PageHeader,
    'news-list': NewsList,
    'news-latest': NewsLatest,
    'job-list': JobList,
    search: Search,
    'gravity-form': GravityForm,
    'gf-checkboxes': GfCheckboxes,
    'gf-consent': GfConsent,
    'gf-file-upload': GfFileUpload,
    'gf-input': GfInput,
    'gf-radio-buttons': GfRadioButtons,
    'gf-select': GfSelect,
    'gf-textarea': GfTextarea,
    gallery: Gallery,
    'page-hero-slider': PageHeroSlider,
    'benefits-slider': BenefitsSlider,
    statistics: Statistics,
    accordion: Accordion,
    collapse: Collapse,
    quote: Quote,
    logowall: Logowall,
  },
  methods: {
    createdHook() {
      window.addEventListener('scroll', this.stickyHeader);
      window.addEventListener('resize', this.positionGallery);
      window.addEventListener('resize', this.positionPageHeroTitle);
      window.addEventListener('resize', this.positionSubPageHeroTitle);
      window.addEventListener('click', this.usercentricsInit);
    },
    mountedHook() {
      this.positionGallery();
      this.positionPageHeroTitle();
      this.positionSubPageHeroTitle();
      this.disableIFrames();
      this.removeCookiesInfoOverlay();
      this.manageSubpageHeroFallbackImage();
    },
    usercentricsInit(event: any) {
      const target = event.target;
      if (target.classList.contains('show-usercentrics-panel')) {
        // @ts-ignore
        UC_UI.showSecondLayer();
      }
    },
    manageSubpageHeroFallbackImage() {
      const video = document.querySelector('.ce-subpage-hero-video');
      const delay = 5000;
      if (video) {
        setTimeout(function() {
          const fallbackImage = document.querySelector<HTMLElement>('.ce-subpage-hero-video-fallback-wrapper');
          if (fallbackImage) {
            fallbackImage.style.display = 'block';
          }
        }, delay);
      }
    },
    removeCookiesInfoOverlay() {
      window.addEventListener('click', (event) => {
        const target = event.target as Element;
        if (target.classList.contains('cookies-info-overlay-text--kununu')) {
          // @ts-ignore
          UC_UI.acceptServices(['ovrsMevF0']).then(() => console.log('Services are accepted'));
        } else if (target.classList.contains('cookies-info-overlay-text')) {
          // @ts-ignore
          UC_UI.acceptServices(['BJz7qNsdj-7', 'HyEX5Nidi-m', 'PzUvFQcta', 'dLnCKuWd-']).then(() => console.log('Services are accepted'));
        }
      });
    },
    disableIFrames(scope:ParentNode = document) {
      window.addEventListener('ucEvent', (event) => {
        if ((<any>event).detail && (<any>event).detail.event === 'consent_status') {
          // Disable iframes - Youtube videos
          if ((<any>event).detail['YouTube Video'] === false) {
            // Create info overlay
            const pTag = document.createElement('p');
            pTag.innerHTML = 'Please enable cookies to view this content';
            pTag.classList.add('cookies-info-overlay-text');
            const divTag = document.createElement('div');
            divTag.classList.add('cookies-info-overlay');
            divTag.appendChild(pTag);
            scope.querySelectorAll<HTMLIFrameElement>('.ce-gallery-item--youtube').forEach((iframe) => {
              iframe.parentNode?.insertBefore(divTag.cloneNode(true), iframe);
            });
          } else if ((<any>event).detail['YouTube Video'] === true) {
            scope.querySelectorAll<HTMLIFrameElement>('.ce-gallery-item--youtube').forEach((iframe) => {
              const iframeUrl = "https://www.youtube.com" + iframe.dataset.video;
              if (iframeUrl) {
                iframe.setAttribute('src', iframeUrl);
                iframe.dataset.video = '';
              }
              const infoOverlay = iframe.parentNode?.querySelectorAll<HTMLElement>('.cookies-info-overlay');
              if (infoOverlay) {
                infoOverlay.forEach((overlay) => {
                  overlay.style.display = 'none';
                });
              }
              iframe.setAttribute('lazy', 'true');
              iframe.style.display = 'block';
            });
          }
          // Disable iframes - Vimeo videos
          if ((<any>event).detail['Vimeo'] === false) {
            // Create info overlay
            const pTag = document.createElement('p');
            pTag.innerHTML = 'Please enable cookies to view this content';
            pTag.classList.add('cookies-info-overlay-text');
            const divTag = document.createElement('div');
            divTag.classList.add('cookies-info-overlay');
            divTag.appendChild(pTag);
            scope.querySelectorAll<HTMLIFrameElement>('.ce-gallery-item--vimeo').forEach((iframe) => {
              iframe.parentNode?.insertBefore(divTag.cloneNode(true), iframe);
            });
          } else if ((<any>event).detail['Vimeo'] === true) {
            scope.querySelectorAll<HTMLIFrameElement>('.ce-gallery-item--vimeo').forEach((iframe) => {
              const iframeUrl = iframe.dataset.video;
              if (iframeUrl) {
                iframe.setAttribute('src', iframeUrl);
                iframe.dataset.video = '';
              }
              const infoOverlay = iframe.parentNode?.querySelectorAll<HTMLElement>('.cookies-info-overlay');
              if (infoOverlay) {
                infoOverlay.forEach((overlay) => {
                  overlay.style.display = 'none';
                });
              }
              iframe.setAttribute('lazy', 'true');
              iframe.style.display = 'block';
            });
          }
          // Disable Kununu widget
          if ((<any>event).detail['Kununu.com'] === false) {
            // Create info overlay
            const pTag = document.createElement('p');
            pTag.innerHTML = 'Please enable cookies to view this content';
            pTag.classList.add('cookies-info-overlay-text--kununu');
            const divTag = document.createElement('div');
            divTag.classList.add('cookies-info-overlay');
            divTag.appendChild(pTag);
            scope.querySelectorAll<HTMLElement>('.kununu-widget').forEach((widget) => {
              if (widget) {
                widget.appendChild(divTag);
              }
            });
          } else if ((<any>event).detail['Kununu.com'] === true) {
            scope.querySelectorAll<HTMLElement>('.kununu-widget').forEach((widget) => {
              const infoOverlay = widget.querySelectorAll<HTMLElement>('.cookies-info-overlay');
              if (infoOverlay) {
                infoOverlay.forEach((overlay) => {
                  overlay.style.display = 'none';
                });
              }
            });
          }
        }
      });
    },
    positionPageHeroTitle() {
      const pageWidth = document.body.clientWidth;
      if (pageWidth > 991) {
        const heroHeadlines = document.querySelector('.ce-page-hero-headlines');
        if (heroHeadlines) {
          const heroHeadlinesOffset = heroHeadlines.getBoundingClientRect().top;
          const heroTitle = document.querySelector<HTMLElement>('.ce-page-hero-wrapper-left-title');
          if (heroTitle) {
            heroTitle.style.top = heroHeadlinesOffset + 'px';
          }
        }
      } else {
        const heroTitle = document.querySelector<HTMLElement>('.ce-page-hero-wrapper-left-title');
        if (heroTitle) {
          heroTitle.style.top = '0px';
        }
      }
    },
    positionSubPageHeroTitle() {
      const pageWidth = document.body.clientWidth;
      if (pageWidth > 991) {
        const heroHeadlines = document.querySelector('.ce-page-hero-title-wrapper');
        if (heroHeadlines) {
          const heroHeadlinesOffset = heroHeadlines.getBoundingClientRect().top;
          const heroTitle = document.querySelector<HTMLElement>('.ce-page-hero-wrapper-left-title');
          if (heroTitle) {
            heroTitle.style.top = heroHeadlinesOffset + 'px';
          }
        }
      }
    },
    stickyHeader() {
      const currentScrollPos = window.pageYOffset;
      const pageWidth = document.body.clientWidth;
      if (pageWidth > 991) {
        if (currentScrollPos !== 0) {
          if (currentScrollPos >= 80) {
            const header = document.querySelector('.header');
            if (header) {
              header.classList.add('header--sticky');
            }
          }
        } else {
          const header = document.querySelector('.header');
          if (header) {
            header.classList.remove('header--sticky');
          }
        }
      } else {
        if (currentScrollPos !== 0) {
          if (currentScrollPos >= 25) {
            const header = document.querySelector('.header');
            if (header) {
              header.classList.add('header--sticky');
            }
          }
        } else {
          const header = document.querySelector('.header');
          if (header) {
            header.classList.remove('header--sticky');
          }
        }
      }
    },
    positionGallery() {
      const elements = document.querySelectorAll<HTMLElement>('.ce-gallery');
      if (elements) {
        elements.forEach((el) => {
          // Top position
          const topPosition = el.getAttribute('data-top');
          const topPositionMobile = el.getAttribute('data-top_mobile');
          if (topPosition && topPositionMobile) {
            if (window.innerWidth <= 991) {
              el.style.top = topPositionMobile + 'px';
            } else {
              el.style.top = topPosition + 'px';
            }
          }
        });
      }
    },
    showJobListFilter() {
      const jobListFilter = document.querySelector('.job-filter-row');
      if (jobListFilter) {
        if (jobListFilter.classList.contains('active')) {
          jobListFilter.classList.remove('active');
        } else {
          jobListFilter.classList.add('active');
        }
      }
    },
  },
};

const app = createApp(projectRootComponent);

app.mount('#page');
